"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dialog = function Dialog(api, data) {
  (0, _classCallCheck3.default)(this, Dialog);

  Object.assign(this, (0, _extends3.default)({ api: api }, data));
};

Dialog._namespace = "dialogs";

Dialog.getDialogs = function (api) {
  return api.getCollection(Dialog, "dialogs");
};

Dialog.getDialog = function (api, id) {
  return api.getObject(Dialog, "dialogs", id);
};

Dialog.createDialog = function (api, data) {
  return api.postObject(Dialog, "dialogs", data);
};

Dialog.updateDialog = function (api, id, data) {
  return api.putObject(Dialog, "dialogs", id, data);
};

Dialog.deleteDialog = function (api, id) {
  return api.deleteObject(Dialog, "dialogs", id);
};

Dialog.getInstances = function (api) {
  return api.getCollection(Dialog, "dialogs?tag=start");
};

exports.default = Dialog;


//////////////////
// WEBPACK FOOTER
// ../sdk/lib/Dialog.js
// module id = 318
// module chunks = 0